export const IMAGE_NOT_FOUND = './assets/not-found.png';
